import { AppState } from '@redux/store/store';
import { createSelector } from '@reduxjs/toolkit';
import { ElementDTOUnion } from '@/model';

const getLayoutEditor = (state: AppState) => state.layoutEditor;

export const selectedElementSelector = createSelector(
  [getLayoutEditor],
  (layoutEditor): ElementDTOUnion | null => {
    if (!layoutEditor.selectedLayoutId) return null;

    const element = layoutEditor.elements.find(
      (element) => element.id === layoutEditor.selectedLayoutId,
    );

    return element ? structuredClone(element) : null;
  },
);
